module.exports = __webpack_public_path__ + "img/iconmonstr-phone-1.312dfb0f.svg";